module.exports = __webpack_public_path__ + "static/media/accomodation.f725e3fa.svg";